<template>
  <div class="new-chat-header">
    <!-- toolbar -->
    <new-chat-dialog-header-toolbar
      :step="step"
      :selected-contacts="selectedContacts"
      :participants-summary="participantsSummary"
      @onPreviousStep="$emit('onPreviousStep')"
      @closeDialog="$emit('closeDialog')"
    />
    <!-- header -->
    <v-container fluid v-if="step % 2 === 1">
      <!-- @todo need to force rerender when dialog is hidden -->
      <bh-input-pill
        :key="`input-${isVisible ? 'visible' : 'hidden'}`"
        :value="searchText"
        bgColor="bhGray6"
        :full-width="true"
        placeholder="Search"
        @input="$emit('contact:search', $event)" />
    </v-container>
    <v-container v-else class="new-chat-header-subject-wrapper pb-11">
      <new-chat-name-section
        :value="subjectText"
        :selectedContacts="selectedContacts"
        :contact-single-selection="contactSingleSelection"
        @chat-subject="$emit('onChatSubject', $event)" />
      <v-btn
        color="primary"
        elevation="0"
        absolute
        bottom
        right
        fab
        large
        :disabled="!subjectTextIsValid"
        @click="$emit('onCreateChat')"
      >
        <v-icon size="24">mdi-arrow-right</v-icon>
      </v-btn>
    </v-container>
    <transition name="new-chat-header-fade">
      <!-- selected contacts -->
      <new-chat-selected-contacts
        v-if="contactSelected && (step % 2 === 1)"
        :selectedContacts="selectedContacts"
        :action-icon="'bhi-close-circle-filled'"
        overflow
        class="mx-6"
        @contact:remove="$emit('contact:selection', $event)" />
    </transition>
  </div>
</template>

<script>
import BhInputPill from "@/components/inputs/BhInputPill.vue"
import NewChatDialogHeaderToolbar from '@/components/chat/components/NewChatDialogHeaderToolbar'
import NewChatNameSection from "@/components/chat/components/NewChatNameSection.vue"
import NewChatSelectedContacts from "@/components/chat/components/NewChatSelectedContacts.vue"

export default {
  name: 'NewChatDialogHeader',
  components: {
    BhInputPill,
    NewChatSelectedContacts,
    NewChatDialogHeaderToolbar,
    NewChatNameSection
  },
  props: {
    step: {
      type: Number,
      default: 0
    },
    selectedContacts: {
      type: Array,
      default: () => []
    },
    participantsSummary: {
      type: String,
      default: ''
    },
    subjectText: {
      type: String,
      default: ''
    },
    searchText: {
      type: String,
      default: ''
    },
    subjectTextIsValid: {
      type: Boolean,
      default: false
    },
    contactSelected: {
      type: Boolean,
      default: false
    },
    isVisible: {
      type: Boolean,
      default: false
    },
    contactSingleSelection: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.new-chat-header {
  &-subject-wrapper {
    position: relative;
  }

  &-fade-enter-active, &-fade-leave-active {
    transition: max-height .3s;
    max-height: $chat-selected-users-section-height;
  }
  &-fade-enter, &-fade-leave-to {
    max-height: 0;
  }
}
</style>
